import { useEffect, useState, useRef } from "react";
import { ffTrack } from "@/lib/tracking";
import { useSearchParams, Link } from "react-router-dom";
import { CheckCircle2, Crown, Loader2, XCircle } from "lucide-react";
import { api } from "@/lib/api";
import { useApp } from "@/context/AppContext";

export default function PaymentResult() {
  const [sp] = useSearchParams();
  const { refreshUser } = useApp();
  const [status, setStatus] = useState("checking");
  const tries = useRef(0);

  useEffect(() => {
    const sid = sp.get("session_id");
    if (!sid) { setStatus("error"); return; }
    const poll = async () => {
      if (tries.current >= 8) { setStatus("timeout"); return; }
      tries.current += 1;
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") { setStatus("paid"); refreshUser(); ffTrack("Purchase", { value: data.amount, currency: (data.currency || "usd").toUpperCase(), content_name: data.plan }); return; }
        if (data.status === "expired" || data.payment_status === "failed") { setStatus("error"); return; }
      } catch { /* retry */ }
      setTimeout(poll, 2000);
    };
    poll();
  }, []); // eslint-disable-line

  return (
    <div className="min-h-[70vh] grid place-items-center px-4">
      <div className="text-center max-w-md">
        {status === "checking" && <><Loader2 className="h-12 w-12 text-primary animate-spin mx-auto" /><h1 className="text-2xl font-display font-bold mt-6">Confirming your payment…</h1></>}
        {status === "paid" && <><div className="h-16 w-16 rounded-full bg-primary/15 grid place-items-center mx-auto"><Crown className="h-8 w-8 text-primary" /></div>
          <h1 className="text-3xl font-display font-bold mt-6">You're Premium! 🎉</h1><p className="text-muted-foreground mt-2">Ad-free, unlimited reading is now unlocked.</p>
          <div className="flex gap-3 justify-center mt-8"><Link to="/discover" className="px-6 py-3 rounded-full bg-primary text-primary-foreground font-semibold">Start Reading</Link><Link to="/profile" className="px-6 py-3 rounded-full border border-border">View Profile</Link></div></>}
        {(status === "error" || status === "timeout") && <><XCircle className="h-12 w-12 text-destructive mx-auto" /><h1 className="text-2xl font-display font-bold mt-6">{status === "timeout" ? "Still processing" : "Payment issue"}</h1>
          <p className="text-muted-foreground mt-2">{status === "timeout" ? "Your payment is taking a while. Check your profile shortly." : "We couldn't confirm your payment."}</p>
          <Link to="/premium" className="inline-block mt-6 px-6 py-3 rounded-full border border-border">Back to Premium</Link></>}
      </div>
    </div>
  );
}
